export default __webpack_public_path__ + "static/media/ears.4cbaf1f2.ogg";